import React from "react";
import "../App.css";

export default function Header() {
  return (
    <div className="title">
      <h1>United States GDP (1947 - 2015)</h1>
    </div>
  );
}
